import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem6,
    GridItem8,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorValor,
    TextValidatorNumber,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    IdadeInicial,
    IdadeFinal,
    AporteMensal,
    RetiradaMensal,
    Observacao,
} from './SimulacaoFinanceiraCompAporteRetiradaMensal'



const SimulacaoFinanceiraFormAporteRetiradaMensalConfiguracao = ({ values, ind, item, handleChange }) => {

    return (
        <>
            <GridContainer>
                <GridItem3>
                    <GridContainer>
                        <GridItem6>
                            <IdadeInicial
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        <GridItem6>
                            <IdadeFinal
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                    </GridContainer>
                </GridItem3>
                <GridItem2>
                    <AporteMensal
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem2>
                {!item.aumentoAporteMensal && (
                    <GridItem3>
                        <TextValidatorNumber
                            name={`aporteRetiradaMensal[${ind}].percReajusteAporteMensal`}
                            label={LABEL.percReajusteAporteMensal}
                            value={item.percReajusteAporteMensal || ''}
                            onChange={handleChange}
                            numMin={NUMMIN.perc}
                            numMax={NUMMAX.perc}
                        />
                    </GridItem3>
                )}
                {!item.percReajusteAporteMensal && (
                    <GridItem3>
                        <TextValidatorValor
                            name={`aporteRetiradaMensal[${ind}].aumentoAporteMensal`}
                            label={LABEL.aumentoAporteMensal}
                            value={item.aumentoAporteMensal || ''}
                            onChange={handleChange}
                        />
                    </GridItem3>
                )}
                {(item.percReajusteAporteMensal || item.aumentoAporteMensal) && (
                    <GridItem4>
                        <TextValidatorNumberRequired
                            name={`aporteRetiradaMensal[${ind}].anosReajusteAumentoAporteMensal`}
                            label={item.percReajusteAporteMensal ? LABEL.anosReajusteAporteMensal : LABEL.anosAumentoAporteMensal}
                            value={item.anosReajusteAumentoAporteMensal || ''}
                            onChange={handleChange}
                            numMin={NUMMIN.anosReajusteAumento}
                            numMax={NUMMAX.anosReajusteAumento}
                        />
                    </GridItem4>
                )}
            </GridContainer>

            <GridContainer>
                <GridItem3/>
                <GridItem2>
                    <RetiradaMensal
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem2>
                {!item.aumentoRetiradaMensal && (
                    <GridItem3>
                        <TextValidatorNumber
                            name={`aporteRetiradaMensal[${ind}].percReajusteRetiradaMensal`}
                            label={LABEL.percReajusteRetiradaMensal}
                            value={item.percReajusteRetiradaMensal || ''}
                            onChange={handleChange}
                            numMin={NUMMIN.perc}
                            numMax={NUMMAX.perc}
                        />
                    </GridItem3>
                )}
                {!item.percReajusteRetiradaMensal && (
                    <GridItem3>
                        <TextValidatorValor
                            name={`aporteRetiradaMensal[${ind}].aumentoRetiradaMensal`}
                            label={LABEL.aumentoRetiradaMensal}
                            value={item.aumentoRetiradaMensal || ''}
                            onChange={handleChange}
                        />
                    </GridItem3>
                )}
                {(item.percReajusteRetiradaMensal || item.aumentoRetiradaMensal) && (
                    <GridItem4>
                        <TextValidatorNumberRequired
                            name={`aporteRetiradaMensal[${ind}].anosReajusteAumentoRetiradaMensal`}
                            label={item.percReajusteRetiradaMensal ? LABEL.anosReajusteRetiradaMensal : LABEL.anosAumentoRetiradaMensal}
                            value={item.anosReajusteAumentoRetiradaMensal || ''}
                            onChange={handleChange}
                            numMin={NUMMIN.anosReajusteAumento}
                            numMax={NUMMAX.anosReajusteAumento}
                        />
                    </GridItem4>
                )}
            </GridContainer>
            <GridContainer>
                <GridItem3/>
                <GridItem8>
                    <Observacao
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem8>
            </GridContainer>
        </>
    )
}

export default SimulacaoFinanceiraFormAporteRetiradaMensalConfiguracao